module.exports = __webpack_public_path__ + "img/SRT341_diesel.6a1f6f25.png";